var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-navigation-drawer",
        {
          attrs: {
            id: "app-drawer",
            src: _vm.image,
            app: "",
            color: "grey darken-2",
            dark: "",
            floating: "",
            "mobile-breakpoint": "1323",
            persistent: "",
            width: "260"
          },
          scopedSlots: _vm._u([
            {
              key: "img",
              fn: function(attrs) {
                return [
                  _c(
                    "v-img",
                    _vm._b(
                      {
                        attrs: {
                          gradient:
                            "to top, rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)"
                        }
                      },
                      "v-img",
                      attrs,
                      false
                    )
                  )
                ]
              }
            },
            {
              key: "append",
              fn: function() {
                return [
                  !_vm.user
                    ? _c(
                        "v-list",
                        { attrs: { dense: "", nav: "" } },
                        [
                          _c("div"),
                          _vm._v(" "),
                          _c(
                            "v-list-item",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.login()
                                }
                              }
                            },
                            [
                              _c(
                                "v-list-item-action",
                                [_c("v-icon", [_vm._v("mdi-login-variant")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item-title",
                                { staticClass: "font-weight-light" },
                                [_vm._v("\n            Login\n          ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "v-list",
                        { attrs: { dense: "", nav: "" } },
                        [
                          _c("div"),
                          _vm._v(" "),
                          _c(
                            "v-list-item",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.openHelpCenter()
                                }
                              }
                            },
                            [
                              _c(
                                "v-list-item-action",
                                [_c("v-icon", [_vm._v("mdi-help")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item-title",
                                { staticClass: "font-weight-light" },
                                [
                                  _vm._v(
                                    "\n            Help center\n          "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item",
                            { attrs: { href: "mailto:support@adnami.io" } },
                            [
                              _c(
                                "v-list-item-action",
                                [_c("v-icon", [_vm._v("mdi-contact-mail")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item-title",
                                { staticClass: "font-weight-light" },
                                [
                                  _vm._v(
                                    "\n            Contact support\n          "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.logout()
                                }
                              }
                            },
                            [
                              _c(
                                "v-list-item-action",
                                [_c("v-icon", [_vm._v("mdi-logout-variant")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item-title",
                                { staticClass: "font-weight-light" },
                                [_vm._v("\n            Log out\n          ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.inputValue,
            callback: function($$v) {
              _vm.inputValue = $$v
            },
            expression: "inputValue"
          }
        },
        [
          _vm._v(" "),
          _c(
            "a",
            { attrs: { href: "/" } },
            [
              _c(
                "v-list-item",
                { attrs: { "two-line": "" } },
                [
                  _c("v-img", {
                    staticClass: "logo",
                    attrs: {
                      src: "/dist/assets/adnami-final-logo_white.png",
                      contain: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider", { staticClass: "mx-3 mb-3" }),
          _vm._v(" "),
          _c(
            "v-list",
            { attrs: { nav: "", dense: "" } },
            [
              _c("div"),
              _vm._v(" "),
              _vm._l(_vm.links, function(link, i) {
                return _c(
                  "span",
                  [
                    link.children && link.children.length > 0
                      ? _c(
                          "v-list-group",
                          {
                            key: i,
                            attrs: {
                              to: link.path,
                              "prepend-icon": link.meta.icon
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function() {
                                    return [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", {
                                            domProps: {
                                              textContent: _vm._s(link.name)
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _vm._v(" "),
                            _vm._l(link.children, function(child) {
                              return child.meta.displayInMenu
                                ? _c(
                                    "v-list-item",
                                    {
                                      key: child.name,
                                      attrs: {
                                        to: child.path,
                                        "prepend-icon": child.meta.icon,
                                        "active-class": "primary white--text"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleClick("")
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", {
                                            domProps: {
                                              textContent: _vm._s(child.name)
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            })
                          ],
                          2
                        )
                      : _c(
                          "v-list-item",
                          {
                            key: i,
                            attrs: {
                              to: link.path,
                              "active-class": "primary white--text"
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleClick(link.name)
                              }
                            }
                          },
                          [
                            _c(
                              "v-list-item-action",
                              [_c("v-icon", [_vm._v(_vm._s(link.meta.icon))])],
                              1
                            ),
                            _vm._v(" "),
                            _c("v-list-item-title", {
                              domProps: { textContent: _vm._s(link.name) }
                            })
                          ],
                          1
                        )
                  ],
                  1
                )
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }